// Page through a Xano list endpoint instead of asking for one giant page.
// Post-8/27 outage: list endpoints cap per_page/limit server-side (200), so any
// "fetch everything" caller must loop. Bounded by maxPages so a runaway loop
// can never pull more than the old 10,000-row ceiling.
//
//   const { items, truncated } = await fetchAllPages(
//     (params) => apiService.getClaims(params),
//     { status: 'ready_to_submit' },
//     { pageSizeKey: 'per_page' }
//   );
//
// responseShape: 'items' (Xano paging envelope: { items, nextPage, ... }) or
// 'flat' (endpoint returns a bare array or { items } without paging metadata).
export async function fetchAllPages(fetchFn, params = {}, options = {}) {
  const {
    pageSize = 200,
    pageSizeKey = 'limit',
    maxPages = 50,
    responseShape = 'items',
  } = options;

  const all = [];
  let page = 1;
  let truncated = false;

  while (true) {
    const result = await fetchFn({ ...params, page, [pageSizeKey]: pageSize });
    const items = Array.isArray(result) ? result : (result?.items || []);
    all.push(...items);

    const exhausted = responseShape === 'flat'
      ? items.length < pageSize
      : (!result?.nextPage || items.length < pageSize);
    if (exhausted) break;

    if (page >= maxPages) {
      truncated = true;
      break;
    }
    page++;
  }

  return { items: all, truncated };
}
